const TRAILER_TYPES = {
  DRY_VAN_53: {
    id: 'DRY_VAN_53',
    label: "Dry Van 53'",
    lengthFt: 53,
    interiorWidthIn: 100,
    interiorHeightIn: 110,
    maxWeightLbs: 45000
  },
  DRY_VAN_48: {
    id: 'DRY_VAN_48',
    label: "Dry Van 48'",
    lengthFt: 48,
    interiorWidthIn: 100,
    interiorHeightIn: 110,
    maxWeightLbs: 45000
  }
}

const DEFAULT_TRAILER_ID = 'DRY_VAN_53'

const TWO_WIDE_MAX_WIDTH_IN = 50
const STACKED_MAX_COMBINED_WEIGHT_LBS = 1500
const MAX_AVG_WEIGHT_PER_LINEAR_FOOT_LBS = 900

const LOAD_STATUS = {
  EMPTY: 'Vide',
  PARTIAL: 'Partiel',
  FULL: 'Plein'
}

function isTwoWide (widthIn) {
  const width = Number(widthIn)
  return width > 0 && width <= TWO_WIDE_MAX_WIDTH_IN
}

function lineTotalWeight (qty, unitWeightLbs) {
  return (parseInt(qty, 10) || 0) * (Number(unitWeightLbs) || 0)
}

// A line = qty identical pallets on the floor: linear feet = (length/12) * qty,
// halved when width <= 50in (two pallets fit side by side).
// A line stacked on another consumes no floor space.
function lineLinearFeet ({ lengthIn, widthIn, qty, stackedOn }) {
  if (stackedOn) return 0
  const feet = ((Number(lengthIn) || 0) / 12) * Math.max(1, parseInt(qty, 10) || 1)
  return isTwoWide(widthIn) ? feet / 2 : feet
}

function capacityPercent (totalLinearFeet, trailer) {
  if (!trailer || !trailer.lengthFt) return 0
  return (totalLinearFeet / trailer.lengthFt) * 100
}

function loadStatusFromPercent (pct) {
  if (pct <= 25) return LOAD_STATUS.EMPTY
  if (pct < 100) return LOAD_STATUS.PARTIAL
  return LOAD_STATUS.FULL
}

export {
  TRAILER_TYPES,
  DEFAULT_TRAILER_ID,
  TWO_WIDE_MAX_WIDTH_IN,
  STACKED_MAX_COMBINED_WEIGHT_LBS,
  MAX_AVG_WEIGHT_PER_LINEAR_FOOT_LBS,
  LOAD_STATUS,
  isTwoWide,
  lineTotalWeight,
  lineLinearFeet,
  capacityPercent,
  loadStatusFromPercent
}
